import HeadlessSpEditor from '@/features/shared/component/HeadlessSpEditor'
import { WorkspaceLayout } from '@/features/workspace'
import ShotListMainContent from '../components/ShotListMainContent'
import SlOptionBar from '../components/SlOptionBar'
import SlSidebar from '../components/SlSidebar'

const ShotListPage = () => {
    return (
        <WorkspaceLayout
            SidebarComponent={<SlSidebar />}
            optionBar={<SlOptionBar />}
        >
            <HeadlessSpEditor />
            <ShotListMainContent />
        </WorkspaceLayout>
    )
}

export default ShotListPage
